import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageView } from '../utils/awsRum';

/**
 * パス → pageId の静的マッピング
 */
const STATIC_PAGE_NAMES: Record<string, string> = {
  '/login': 'login',
  '/home': 'home',
  '/shift-schedule': 'shift-schedule',
  '/work-schedule': 'work-schedule',
  '/tenant-settings': 'tenant-settings',
  '/work-rules': 'work-rules',
  '/organization': 'organization',
  '/employees': 'employees',
  '/employees/new': 'employee-form',
  '/employees/new/work-rules': 'work-rule-form',
  '/employees/new/support': 'support-form',
  '/employees/new/tags': 'tag-form',
  '/shift-patterns': 'shift-patterns',
  '/shift-patterns/new': 'shift-pattern-form',
  '/tasks': 'tasks',
  '/display-settings': 'display-settings',
  '/analytics': 'analytics',
  '/notifications': 'notifications',
  '/settings': 'settings',
};

/**
 * 動的パス（:id 等）のパターンマッチング
 * [正規表現, pageId] のペア配列
 */
const DYNAMIC_PAGE_PATTERNS: [RegExp, string][] = [
  [/^\/employees\/[^/]+\/edit$/, 'employee-form'],
  [/^\/employees\/[^/]+\/work-rules$/, 'work-rule-form'],
  [/^\/employees\/[^/]+\/support$/, 'support-form'],
  [/^\/employees\/[^/]+\/tags$/, 'tag-form'],
  [/^\/shift-patterns\/[^/]+\/edit$/, 'shift-pattern-form'],
  [/^\/settings\/work-rules\/[^/]+$/, 'work-rules-detail'],
];

/**
 * パス名から pageId を解決する
 */
function resolvePageName(pathname: string): string {
  // 静的マッチを先に試す
  const staticMatch = STATIC_PAGE_NAMES[pathname];
  if (staticMatch) return staticMatch;

  // 動的パターンを順に試す
  for (const [pattern, pageId] of DYNAMIC_PAGE_PATTERNS) {
    if (pattern.test(pathname)) return pageId;
  }

  // マッチしない場合はパスをそのまま使う（リダイレクト先等）
  return pathname;
}

/**
 * ページ遷移時に CloudWatch RUM へページビューを記録する Hook
 * Router 内で1回だけ呼び出す
 */
export function usePageViewTracker(): void {
  const location = useLocation();

  useEffect(() => {
    const pageName = resolvePageName(location.pathname);
    recordPageView(pageName);
  }, [location.pathname]);
}
